import React from "react";
import {QuestionDisplayProps} from "../Question";
import {SortQuestionDefinition} from "../../../state/questions";
import {createUseStyles} from "react-jss";
import {Theme} from "engage-client/theme";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";

const Height = 110;
const Border = 3;

const useStyles = createUseStyles<Theme>((theme) => ({
	sortInput: {
		display: "flex",
		flexDirection: "column",
	},
	option: {
		display:"flex",
		alignItems:"center",
		justifyContent:"center",
		border: `${Border}px solid ${theme.color.primary.main}`,
		borderRadius: 10,
		height: Height - Border * 2,
		margin: 8
	},
}));

export default function SortInput({state, question}: QuestionDisplayProps) {
	const classes = useStyles();
	const sortQuestion = question as SortQuestionDefinition;
	const indices = sortQuestion.options.map( (_,index) => index );

	return <div className={classes.sortInput}>
			{indices.map((item, index) => (
				<div className={classes.option}>
					<DisplayText variant={TextVariant.s28reg}>{sortQuestion.options[item]}</DisplayText>
				</div>
			))}
	</div>;
}